import { useEffect, useRef } from "react";

// Opens a WebSocket to the backend and invokes `onEvent` whenever an order
// for this restaurant changes. Auto-reconnects on drop. The message only
// signals "refetch" — callers pull fresh data via the authenticated REST API.
export function useRealtimeOrders(rid, onEvent) {
  const cbRef = useRef(onEvent);
  cbRef.current = onEvent;

  useEffect(() => {
    if (!rid) return;
    const base = process.env.REACT_APP_BACKEND_URL || "";
    const wsUrl = base.replace(/^http/, "ws") + `/api/ws/orders/${rid}`;
    let ws;
    let closed = false;
    let retry;

    const connect = () => {
      if (closed) return;
      try {
        ws = new WebSocket(wsUrl);
      } catch {
        retry = setTimeout(connect, 5000);
        return;
      }
      ws.onmessage = (e) => {
        try {
          const data = JSON.parse(e.data);
          cbRef.current?.(data);
        } catch {
          cbRef.current?.({ type: "orders_changed" });
        }
      };
      ws.onclose = () => {
        if (!closed) retry = setTimeout(connect, 3000);
      };
      ws.onerror = () => {
        try { ws.close(); } catch { /* noop */ }
      };
    };
    connect();

    return () => {
      closed = true;
      clearTimeout(retry);
      try { ws && ws.close(); } catch { /* noop */ }
    };
  }, [rid]);
}
